const zIndex = {
  lowZIndex: 2,
  middleZIndex: 3,
  highZIndex: 4,
  highestZIndex: 9,
};
export default zIndex;
